export default __webpack_public_path__ + "static/media/active.aad2a587.svg";